// @ts-strict-ignore
import type { FetchRequestError } from "@lib/errors";

import type { AllRouteEndpoints } from "../routeTypes";
import type { MutationFetcherFunctionWithShadowError } from "../types";
import { invalidateCacheKeys } from "./invalidateCacheKeys";

/**
 * Adapter to trigger invalidation of existing queries upon successful execution of a mutation
 */
export const reactQueryMutationAdapter = <Arguments, Result, Error extends FetchRequestError>(
  invalidationQueryKeys: AllRouteEndpoints | AllRouteEndpoints[],
  fetcherFunction: MutationFetcherFunctionWithShadowError<Error, Arguments, Result>
): MutationFetcherFunctionWithShadowError<Error, Arguments, Result> => {
  const result = (args: Arguments, customizedFetcherFunction?: Function, directCallFetcher = false) => {
    // If directCallFetcher is true, we are calling the fetcher directly with passed in args
    if (directCallFetcher) {
      return fetcherFunction(args);
    }

    // If customizedFetcher is provided, we use that instead of the default fetcherFunction
    const activeFetcherFunction = customizedFetcherFunction || fetcherFunction;

    return activeFetcherFunction(args).then((result) => {
      invalidateCacheKeys(invalidationQueryKeys);
      return result;
    });
  };
  return result as MutationFetcherFunctionWithShadowError<Error, Arguments, Result>;
};
